import moment				from 'moment';

import {LanguageType}		from '../language/type';


export const NETWORK_LIST = [
	'Wi-Fi',
	'Wifi + 4G',
	'Wifi + 4/5G',
	'Wifi + 5G',
	'4/5G',
	'4G',
	'5G'
];

export const KEYBOARD_LIST = [
	'Français - AZERTY',
	'Anglais international - QWERTY',
	'Anglais britannique - QWERTY',
	'Anglais américain - QWERTY',
	'Allemand - QWERTY',
	'Arabe',
	'Chinois (Pinyin)',
	'Espagnol - QWERTY',
	'Italien - QWERTY',
	'Portugais - QWERTY',
	'Suisse - QWERTZ',
	'Turc - QWERTY',
	'Russe - ЙЦУКЕН'
];

export const TYPE_LIST: (keyof LanguageType['global'])[] = [
	'computer',
	'tablet',
	'phone',
	'computers',
	'tablets',
	'phones',
	'hub',
	'headphones',
	'mouse',
	'speaker',
	'screen',
	'other'
];

export const SCREEN_COMPATIBILITY = [
	'Windows',
	'MacOS',
	'Linux'
];

export const SCREEN_PORTS = [
	'VGA',
	'DVI',
	'HDMI',
	'HDMI x 2',
	'HDMI x 3',
	'DisplayPort',
	'DisplayPort x 2',
	'DisplayPort x 3',
	'HDMI 1.4',
	'HDMI 2.0',
	'HDMI 2.1',
	'DisplayPort 1.2',
	'DisplayPort 1.3',
	'DisplayPort 1.4'
];

export const MOUSE_CONNECTIVITY = [
	'Sans fil',
	'USB',
	'USB-C'
];

export const HEADPHONES_TYPE = [
	'Casque',
	'Ecouteurs'
];

export const HEADPHONES_CONNECTIVITY = [
	'Sans fil',
	'Jack',
	'USB',
	'USB-C'
];

export const SPEAKER_CONNECTIVITY = [
	'Bluetooth',
	'Câble'
];

export const KEYBOARD_COMPATIBILITY = [
	'Windows',
	'MacOS',
	'Linux'
];

export const KEYBOARD_CONNECTIVITY = [
	'Bluetooth',
	'Câble'
];

export const HUB_COMPATIBILITY = [
	'Windows',
	'MacOS',
	'Linux'
];

export const HUB_CONNECTIVITY = [
	'Bluetooth',
	'Câble'
];

export const HUB_PORTS = [
	'USB',
	'USB-C'
];

export const SCREEN_STAND = [
	'Pivot',
	'Hauteur',
	'Inclinaison'
];

const MEMORY_LIST: string[] = [];
const STOCKAGE_LIST: string[] = [];
const YEAR_LIST: string[] = [];

for (let i = 0; i <= 512; i += 2)
	MEMORY_LIST.push(`${i === 0 ? 1 : i} Go`);

for (let i = 1; i <= 1000; i *= 2)
	STOCKAGE_LIST.push(`${i} Go`);


for (let i = 1; i <= 10; i++)
	STOCKAGE_LIST.push(`${i} To`);

for (let i = parseInt(moment().format('YYYY'), 10) + 1; i >= 2000; i--)
	YEAR_LIST.push(i.toString());

export {MEMORY_LIST, STOCKAGE_LIST, YEAR_LIST};